import React, { useState } from "react";
import "../styles/About.css";
import aboutUsImg from "../assets/about_us.jpg";
import {
  FaBullseye,
  FaEye,
  FaIdBadge,
  FaCogs,
  FaTimes,
  FaLinkedin,
} from "react-icons/fa";

import Ananth_Somayaji_Img from "../assets/Ananth_Somayaji.jpeg";
import Arun_Kumar_Img from "../assets/Arun_Kumar.jpeg";
import Vikas_V_Img from "../assets/Vikas_V.jpeg";
//import Rajesh_M_Img from "../assets/Rajesh_M.jpeg";


//import R_A_Phaneendra_Img from "../assets/R_A_Phaneendra.jpeg";
import Subramanya_Joshi_Img from '../assets/Subramanya_Joshi_Img.jpeg';

const About = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  const founders = [
    {
      name: "Ananth Somayaji CNS",
      role: "Founder, CEO",
      quote: '"Success is forged in innovation and tempered with purpose."',
      description: "Over 30 years of experience in the IT industry",
      image: Ananth_Somayaji_Img,
      linkedin: "https://www.linkedin.com/in/anantha-somayaji-3730582",
    },
    {
      name: "Arun Kumar R",
      role: "Co-founder, CFO",
      quote: '"Finance drives growth when guided by vision."',
      description: "30 years of experience in Finance and Legal domains",
      image: Arun_Kumar_Img,
      linkedin: "https://www.linkedin.com/in/arun-kumar-249829389",
    },
    {
      name: "Vikas V",
      role: "Co-founder, CMO",
      quote: '"Marketing is storytelling powered by strategy."',
      description:
        "15 years of experience in Sales, Marketing, and Business growth",
      image: Vikas_V_Img,
      linkedin: "https://www.linkedin.com/in/vikas-v-173951153",
    },
   /* {
      name: "Rajesh M",
      role: "Co-founder, CHRO",
      quote: '"People make the mission possible."',
      description:
        "7 years of experience in Human Resource and Business development.",
      image: Rajesh_M_Img,
      linkedin: "https://www.linkedin.com/in/rajesh-m-870492167",
    },*/
  ];

  const management = [
    // {
    //   name: "Ravindra Srikantaiah",
    //   role: "Chief Operating Officer (COO)",
    //   quote: '"Execution is the bridge between ideas and success."',
    //   description:
    //     "28+ years of global leadership driving transformation, scalable growth, and technology-led business impact across industries.",
    //   image: Ravindra_Srikantaiah_Img,
    //   linkedin: "https://www.linkedin.com/in/ravindrasrikant",
    // },
   /* {
      name: "R A Phaneendra",
      role: "Vice President, Sales and Marketing",
      quote: '"Sales is the heartbeat of customer connection."',
      description: "30 years of experience in Hardcore Marketing and Sales.",
      image: R_A_Phaneendra_Img,
      linkedin: "https://www.linkedin.com/in/phaneendra",
    },*/
    // {
    //   name: "Rajiv V D",
    //   role: "Head of Engineering",
    //   quote: '"Quality is not an act, it’s a habit."',
    //   description:
    //     "20+ years of experience in Agile Traditional Development & Testing.",
    //   image: Rajeev_Dixit_Img,
    //   linkedin: "https://www.linkedin.com/in/rajiv-vd-4b237738a/",
    // },
    {
      name: "Subramanya Joshi",
      role: "Vice President, Business Strategist",
      quote: '"Strong strategy builds lasting growth"',
      description:
        "14 years of experience in Entrepreneurship, Journalism, and Technology innovation.",
      image: Subramanya_Joshi_Img,
      linkedin: "https://www.linkedin.com/in/subramanyajoshi"
    },
  ];

  return (
    <section className="about" id="about">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="about-hero-content">
          <div className="about-text" data-aos="fade-up">
            <h1>About Us</h1>
            <p>
              At Venturebiz Promotions Pvt Ltd (VPPL), we are not just a
              company - we are a movement. Rooted in Bengaluru, we redefine how
              businesses and communities grow together through innovation,
              consulting, and technology.
            </p>
            <p>
              We harness cutting-edge technology, deep market insights, and
              strategic consulting to craft solutions that transform vision into
              reality.
            </p>
          </div>
          <div className="about-image" data-aos="zoom-in">
            <img src={aboutUsImg} alt="About Us" />
          </div>
        </div>
      </div>

      {/* Cards Section */}
      <div className="about-cards">
        <div className="about-card" data-aos="fade-up" data-aos-delay="100">
          <FaBullseye className="about-icon" />
          <h3>Our Mission</h3>
          <p className="about-us-card-description">
            Simplify business processes with scalable, secure SaaS solutions
            that drives smarter growth and better customer experience for
            organizations for all sizes.
          </p>
        </div>

        <div className="about-card" data-aos="fade-up" data-aos-delay="200">
          <FaEye className="about-icon" />
          <h3>Our Vision</h3>
          <p className="about-us-card-description">
            Building a future where every business grows sustainably, connects
            hyper local, and transformations industries through digital
            solutions.
          </p>
        </div>

        <div className="about-card" data-aos="fade-up" data-aos-delay="300">
          <FaCogs className="about-icon" />
          <h3>What We Do</h3>
          <p className="about-us-card-description">
            We drive digital growth through marketing, startup support,
            community programs, consulting, and hyperlocal platforms like
            OfferBeez.
          </p>
        </div>

        <div className="about-card" data-aos="fade-up">
          <FaIdBadge className="about-icon" />
          <h3>Our Identity</h3>
          <p className="about-us-card-description">
            We stand at the intersection of innovation, business growth, and
            community connect. Our approach merges technology, strategy, and
            creativity to deliver measurable impact.
          </p>
        </div>
      </div>

      {/* Founders */}
      <div className="founders" data-aos="fade-up">
        <h3>Meet Our Founders</h3>
        <div className="founder-grid-1">
          {founders.map((founder, index) => (
            <div
              key={index}
              className="founder-card"
              data-aos="zoom-in"
              onClick={() => setSelectedMember(founder)}
            >
              <FaLinkedin className="info-icon" title="View Details" />
              <img src={founder.image} alt={founder.name} />
              <h4 className="founders-role">{founder.name}</h4>
              <p>{founder.role}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Management */}
      <div className="founders" data-aos="fade-up">
        <h3>Our Management</h3>
        <div className="founder-grid-1">
          {management.map((member, index) => (
            <div
              key={index}
              className="founder-card"
              data-aos="zoom-in"
              onClick={() => setSelectedMember(member)}
            >
              <FaLinkedin className="info-icon" title="View Details" />
              <img src={member.image} alt={member.name} />
              <h4>{member.name}</h4>
              <p>{member.role}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Overlay */}
      {selectedMember && (
        <div className="ceo-overlay" onClick={() => setSelectedMember(null)}>
          <div
            className="ceo-overlay-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-btn"
              onClick={() => setSelectedMember(null)}
            >
              <FaTimes />
            </button>
            <img src={selectedMember.image} alt={selectedMember.name} />
            <h2>{selectedMember.name}</h2>
            <h4>{selectedMember.role}</h4>
            <p className="ceo-description">{selectedMember.description}</p>
            <p className="ceo-quote">{selectedMember.quote}</p>
            {selectedMember.linkedin && (
              <a
                href={selectedMember.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin-btn"
              >
                <FaLinkedin className="linkedin-icon" /> LinkedIn
              </a>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default About;
